import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Scatter } from 'react-chartjs-2';

// ChartJS.register( ArcElement, Tooltip, Legend );
ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);


const ScatterChart = ({ labTesting, title = '', isRoundup = false, uniqName }) => {

  const chartRef = useRef( null )

  const [ maxX, setMaxX ] = useState( 280 )

  const [ fontSize, setFontSize ] = useState( 14 )

  useEffect(() => {

    if ( window.innerWidth <= 768 ) {
      setFontSize( 10 )
      return
    }

    const chart = chartRef.current;
  
    const handleResize = () => {

      if ( ! chart ) {
        return
      }

      if ( window.innerWidth <= 768) {
        setFontSize(10); // Adjust font size for smaller screens
      } else {
        setFontSize(14); // Default font size for larger screens
      }
      chart.update(); // Ensure the chart updates with the new font size
    };
  
    // Set initial font size based on window width
    handleResize();
  
    // Add resize event listener
    window.addEventListener('resize', handleResize);
  
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {

    const chart = chartRef.current;

    if ( chart ) {
      const ctx = chart.ctx;
      const chartArea = chart.chartArea;

      // Define the ranges and their respective colors based on X-axis
      const xRanges = [
        { label: 'Very Rumbly', start: 25, end: 66.99, color: 'rgb(244, 231, 234)' }, 
        { label: 'Rumbly', start: 67, end: 89.99, color: 'rgb(237, 206, 215)' }, 
        { label: 'Buzzy', start: 90, end: 106.99, color: 'rgb(225, 176, 191)' }, 
        { label: 'Very Buzzy', start: 107, end: maxX, color: 'rgba(214, 134, 163, 0.9)' }, 
      ];

      // Add a new plugin to draw the colored overlays before the chart is drawn
      ChartJS.register({
        id: 'coloredOverlay',
        beforeDraw: (chart) => {

          const { left, right, top, bottom } = chart.chartArea;

          ctx.save();

          xRanges.forEach(({ start, end, color, label }) => {
            const xStart = chart.scales.x.getPixelForValue(start); // Convert X start to pixel
            const xEnd = chart.scales.x.getPixelForValue(end);   // Convert X end to pixel
  
            // Ensure that xStart and xEnd values are within the chart area
            if (xStart >= left && xEnd <= right) {
              // Draw the background rectangle
              ctx.fillStyle = color;
              ctx.fillRect(xStart, top, xEnd - xStart, bottom - top);
  
              // Add the label to the center of the colored range
              const xMid = (xStart + xEnd) / 2; // Calculate the midpoint for the label
              ctx.fillStyle = 'rgba(0, 0, 0, 0.7)'; // Text color (dark)
              ctx.font = '12px HelveticaNue'; // Font style
              ctx.textAlign = 'center'; // Center align text
              ctx.textBaseline = 'middle'; // Middle align text vertically
  
              // Draw the label slightly below the top of the chart
              ctx.fillText(label, xMid, top + 20); // Adjust '20' for vertical positioning
            }
          });
          ctx.restore();
        },
      });

      chart.update(); // Trigger chart update

    }
  }, []);

  // Add tooltip on X-axis title
  useEffect(() => {

    // const chart = chartRef.current;

    // if (chart) {
    //   // Register a custom plugin
    //   ChartJS.register({
    //     id: 'tooltipOnAxisTitle',
    //     afterDraw(chart) {
    //       const ctx = chart.ctx;
    //       const xAxis = chart.scales.x;

    //       // Add interaction area for X-axis title
    //       const hoverArea = {
    //         x: xAxis.left,
    //         y: xAxis.bottom + 5,
    //         width: xAxis.width,
    //         height: 20,
    //       };

    //       // Check if mouse is hovering over the title
    //       chart.canvas.addEventListener('mousemove', (event) => {
    //         const { offsetX, offsetY } = event;

    //         const isHoveringXAxisTitle =
    //           offsetX >= hoverArea.x &&
    //           offsetX <= hoverArea.x + hoverArea.width &&
    //           offsetY >= hoverArea.y &&
    //           offsetY <= hoverArea.y + hoverArea.height;

    //         const tooltip = chart.tooltip;

    //         if ( isHoveringXAxisTitle ) {
              
    //           // Set the tooltip position and display a custom message
    //           tooltip.setActiveElements([], {
    //             x: offsetX,
    //             y: offsetY,
    //           });

    //           tooltip.update({
    //             opacity: 1,
    //             body: [
    //               {
    //                 lines: [ 'This is the X-axis title: "Rumbly/Buzzy"' ],
    //               },
    //             ],
    //           });
    //         } else {
    //           tooltip.setActiveElements([]);
    //           tooltip.update({ opacity: 0 });
    //         }
    //       });
    //     },
    //   });
    //   chart.update();
    // }
  }, []);

  let data = {
    datasets: [],
  };


  let d1 = []

  if ( isRoundup ) {

    if ( labTesting === '[]') {
      return null
    }

    const tests = JSON.parse( labTesting )

    let dataSet = []

    tests.forEach( ( item, index ) => {

      let d2 = []

      item.lab_testing.map(( itm ) => {

        const vp = parseFloat( itm.velocity ) + ( parseFloat( itm.displacement ) * 10 )
    
        const rb = parseFloat( itm.frequency ) - ( ( parseFloat( itm.displacement ) ) * 10 )
            
        d2.push({
          y: vp,
          x: rb,
          customLabel : [
            item.title,
            `Power - ${vp?.toFixed(1)}`,
            `Rumbly/Buzzy - ${rb?.toFixed(1)}`,
            `Sound - ${itm.sound} dB`
          ]
        })
    
      })


      const colors = [
        'rgb(234, 67, 53)',  // Original Red
        'rgb(0, 188, 212)',  // Cyan
        'rgb(76, 175, 80)',  // Bright Green
        'rgb(255, 235, 59)', // Yellow
        'rgb(33, 150, 243)', // Dark Blue
        'rgb(156, 39, 176)', // Magenta
        'rgb(3, 169, 244)',  // Light Cyan
        'rgb(139, 195, 74)', // Light Green
        'rgb(0, 150, 136)',  // Teal
        'rgb(255, 152, 0)',  // Orange
        'rgb(103, 58, 183)', // Purple
        'rgb(0, 100, 0)',    // Deep Green
        'rgb(255, 193, 7)',  // Gold
        'rgb(0, 122, 255)',  // Electric Blue
        'rgb(170, 0, 255)',  // Light Purple
        'rgb(64, 224, 208)'  // Turquoise
      ];

      dataSet.push({
        label: item.title,
        data: d2,
        // backgroundColor: 'rgb(255, 99, 132)',
        backgroundColor: colors[ index ],
        pointRadius: (context) => {
          const dataPoint = context.raw; // Access the raw data point
          return dataPoint.size || 6; // Default size is 5
        },
        pointHoverRadius: (context) => {
          const dataPoint = context.raw; // Access the raw data point
          return dataPoint.size || 8; // Default size is 5
        }
      })

    })

    data = {
      datasets: dataSet
    }

  } else {

    if ( labTesting.tests === null ) {
      return null
    }

    labTesting.tests.map(( item, index ) => {

      const velocity = parseFloat( item.velocity )

      const frequency = parseFloat( item.frequency )

      const displacement = parseFloat( item.displacement )

      const vp = velocity + ( displacement * 10 )
  
      const rb = frequency - ( ( displacement ) * 10 )
  
      d1.push({
        y: vp,
        x: rb,
        customLabel : [
          title,
          `Power - ${vp.toFixed(1)}`,
          `Rumbly/Buzzy - ${rb.toFixed(1)}`,
          `Sound - ${item.sound} dB`
        ]
      })
  
    })

    data = {
      datasets: [{
        label: 'Vibration Power',
        data: d1,
        // backgroundColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgb(234, 67, 53)',
        pointRadius: (context) => {
          const dataPoint = context.raw; // Access the raw data point
          return dataPoint.size || 6; // Default size is 5
        },
        pointHoverRadius: (context) => {
          const dataPoint = context.raw; // Access the raw data point
          return dataPoint.size || 8; // Default size is 5
        }
      }]
    }
  }

 

  // Check max X value
  if ( maxX === 280 ) {

    if ( ! isRoundup ) { // For Single Products
      const maxXValue = Math.max(...d1.map(item => item.x))
      if ( maxXValue + 30 <= 280 ) {
        const val = Math.round( maxXValue + 30 )
        setMaxX( val )
      }
    } else { // For Roundups
      
      const values = []

      data.datasets.forEach( item => {
        item.data.forEach(itm => {
          values.push({
            x: itm.x
          })
        })
      
      })

      const maxXValue = Math.max(...values.map(item => item.x))
      if ( maxXValue + 30 <= 280 ) {
        const val = Math.round( maxXValue + 30 )
        setMaxX( val )
      }

    }

  }
  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    // layout: {
    //   padding: {
    //     top: 30,
    //     bottom: 30, // Adds margin below the legend
    //   },
    // },
    plugins: {
      legend: {
        display: isRoundup,
        position: 'top',
        labels: {
          usePointStyle: true, // Makes legend markers rounded
          pointStyle: 'circle', // Ensures the point style is a circle
          padding: 20, // Adds padding inside the legend box
        },
        onHover: ( event, legendItem, legend ) => {
          const canvas = legend.chart.canvas;
          canvas.style.cursor = 'pointer';
        },
        onLeave: ( event, legendItem, legend ) => {
            const canvas = legend.chart.canvas;
            canvas.style.cursor = 'default';
        }
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) => {
            // Get the custom label from the data
            const dataPoint = tooltipItem.raw; // Access the raw data point
            // const x = dataPoint.x;
            // const y = dataPoint.y;
            const customLabel = dataPoint.customLabel || '';

            return customLabel
            // return `${customLabel}: (x: ${x}, y: ${y})`;
          },
        },
      },
    },
    scales: {
      x: {
        type: 'linear',
        position: 'bottom',
        min: 25,
        max: maxX,
        title: {
          display: true, // Enable the title
          text: 'Rumbly/Buzzy', // Set the label for the x-axis
          font: {
            size: fontSize, // Font size for the label
            weight: 'bold', // Font weight for the label
          },
          color: '#1D1D1F', // Color for the label
          onHover: () => {

          }
        },
      },
      y: {
        type: 'linear',
        title: {
          display: true, // Enable the title
          text: 'Vibration Power', // Set the label for the x-axis
          font: {
            size: fontSize, // Font size for the label
            weight: 'bold', // Font weight for the label
          },
          color: '#1D1D1F', // Color for the label
        },
      },
    },
  };

  return (
    <div>
      <div className={ isRoundup ? 'wrapper-roundup' : ''} style={{ margin : ! isRoundup ? '20px 0 40px' : '', height: '500px' }}>
        <Scatter data={data} options={options} ref={chartRef} key={uniqName}/>
      </div>
    </div>
  );
};

export default ScatterChart;